import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  adressCountryName: {
    id: 'components.Footer.adress.countryName',
    defaultMessage:
      'Sienkiewicza 110 <br> 15-005 Białystok, Polska <br> tel. +48 664 187 124'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/Layout/components/Footer/Footer.intl.js